module.exports = __webpack_public_path__ + "img/file-zip.0c893e7e.svg";